/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintResource } from "./ConstraintResource";
export const ConstraintResponse = core.serialization.object({
    data: ConstraintResource,
});
